import { c as _c } from "react/compiler-runtime";
import React from "react";
const PodiumPlaceholderCard = t0 => {
  const $ = _c(6);
  const {
    height
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-absolute tw-left-1/2 -tw-translate-x-1/2 -tw-top-6 tw-z-10"><div className="tw-w-12 tw-h-12 tw-rounded-xl tw-bg-iron-800/80 tw-animate-pulse" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `tw-flex tw-flex-col tw-items-center tw-justify-center tw-w-full ${height} tw-bg-iron-900/80 tw-rounded-xl tw-border tw-border-iron-800/60 tw-backdrop-blur-xl tw-pt-8`;
  let t3;
  let t4;
  let t5;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="tw-w-24 tw-h-4 tw-mb-2 tw-rounded-lg tw-bg-iron-800/80 tw-animate-pulse" />;
    t4 = <div className="tw-w-20 tw-h-4 tw-mb-2 tw-rounded-lg tw-bg-iron-800/80 tw-animate-pulse" />;
    t5 = <div className="tw-w-16 tw-h-4 tw-rounded-lg tw-bg-iron-800/80 tw-animate-pulse" />;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
  } else {
    t3 = $[1];
    t4 = $[2];
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t2) {
    t6 = <div className="tw-relative">{t1}<div className={t2}>{t3}{t4}{t5}</div></div>;
    $[4] = t2;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  return t6;
};
export const WaveWinnersLoading: React.FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="tw-grid tw-grid-cols-3 tw-gap-3 tw-items-end tw-px-4 tw-pb-4 tw-pt-8"><PodiumPlaceholderCard height="tw-h-32" /><PodiumPlaceholderCard height="tw-h-40" /><PodiumPlaceholderCard height="tw-h-28" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};